import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledContainer = styled.div`
  height: 100vh;
  width: 100%;
`;

const StyledSharedContainer = styled.div`
  position: absolute;
  display: flex;
  right: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  left: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  justify-content: space-between;
  height: fit-content;
`;

export const StyledTopContainer = styled(StyledSharedContainer)`
  top: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
`;

export const StyledBottomContainer = styled(StyledSharedContainer)`
  bottom: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
`;

export const StyledCenterBottomContainer = styled(StyledSharedContainer)`
  bottom: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  left: 50%;
  transform: translateX(-50%);
  width: 70px;
`;

export const StyledWrapper = styled.div<{ width?: number }>`
  display: flex;
  position: relative;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  .ant-skeleton {
    width: 100% !important;
  }

  .ant-skeleton-image {
    width: 100% !important;
    height: ${({ theme }) => utils.rem(theme.Sizes.X6Large)} !important;
    border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)} !important;
  }
`;

export const StyledFlexWrapperWithGap = styled.div`
  display: flex;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
`;

export const StyledFullScreenWrapper = styled.div`
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  .ant-skeleton {
    width: 100% !important;
    height: 100% !important;
  }

  .ant-skeleton-image {
    width: 100% !important;
    height: 100% !important;
    border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Large)} !important;
  }
`;
